import { Stack } from "@mui/material";
import { HTMLAttributes } from "react";

import { cn } from "../../utils/styling";
import { Icon } from "../Icon";
import { Tooltip } from "../Tooltip";

export type DynamicChartTitleProps = {
  className?: string;
  props: Omit<HTMLAttributes<HTMLDivElement>, "className">;
  title: string;
  tooltip: string;
};

export const DynamicChartTitle = ({ className, title, tooltip, ...props }: DynamicChartTitleProps) => {
  return (
    <Stack className={cn("w-full items-center justify-center gap-2", className)} {...props}>
      <h3 className="font-ds-headline-lg">{title}</h3>
      {tooltip && title && (
        <Tooltip title={<pre className="whitespace-pre-wrap">{tooltip}</pre>} tooltipClassName="cancelDrag">
          <div>
            <Icon color="var(--color-element-primary-initial)" iconName="Info" size="md" />
          </div>
        </Tooltip>
      )}
    </Stack>
  );
};
